import React from "react";
import ProductCard from "../../Shared/Product/ProductCard";

const GridViewCard = ({ product }) => {
  return <ProductCard product={product} />;
};

export default GridViewCard;
